import { inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { IPricingTransporterConfiguration } from '../models/pricing-transporter.configuration';
import { ITransportConfigurationService } from './i-transport-configuration.service';
import { API_ENDPOINTS } from '../models/enums/endpoints.enum';
import { ApiProviderService } from './api-provider.service';
import { tap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class PricingTransporterConfigurationService implements ITransportConfigurationService<IPricingTransporterConfiguration> {
  readonly #apiProvider = inject(ApiProviderService);

  private config?: IPricingTransporterConfiguration;

  public publicResourceUrl = API_ENDPOINTS.TRANSPORTER_CONFIGURATION;
  public moderatorResourceUrl = API_ENDPOINTS.MODERATOR_TRANSPORTER_CONFIGURATION;

  retrieveConfiguration(transporterId?: number): Observable<HttpResponse<IPricingTransporterConfiguration>> {
    if (this.config) {
      return of(
        new HttpResponse<IPricingTransporterConfiguration>({
          body: this.config,
        })
      );
    }
    return this.#apiProvider.publicGet<IPricingTransporterConfiguration>(this.publicResourceUrl('pricing', transporterId), { observe: 'response' }).pipe(
      tap((response: HttpResponse<IPricingTransporterConfiguration>) => {
        this.config = response.body!;
      })
    );
  }

  updateConfiguration(configuration: IPricingTransporterConfiguration, transporterId?: number): Observable<HttpResponse<IPricingTransporterConfiguration>> {
    return this.#apiProvider.configurationPut<IPricingTransporterConfiguration>(this.moderatorResourceUrl('pricing', transporterId), configuration);
  }
}
